var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        _vm._b(
          {
            attrs: {
              "custom-class": `c-chat_drawer ${
                _vm.appendToBody ? "c-chat_drawer-tobody" : ""
              }`,
              wrapperClosable: false,
              size: _vm.size,
              visible: _vm.drawerVisible,
              withFooter: false,
              modal: false,
              "modal-append-to-body": _vm.modalAppendToBody,
              "append-to-body": _vm.appendToBody,
            },
            on: {
              "update:visible": function ($event) {
                _vm.drawerVisible = $event
              },
            },
          },
          "el-drawer",
          _vm.$attrs,
          false
        ),
        [_vm._t("content")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }